import React, { useState, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import DataManagement from 'modules/data-management';
import { capitalize, head, startCase } from 'lodash';
import { usePersistState } from 'helper';
import List from 'partial/components/List';
import SearchBar from 'partial/components/input/SearchBar';
import Card from 'partial/components/Card';
// import Button from 'partial/components/Button';
import { useCategoryList } from './hooks';
// import { useOpenCategorySetup } from './modals/CategorySetup';
import ContentDetails from './containers/ContentDetails';

function ContentManagement() {
  const [isLoading, list] = useCategoryList({});
  // const openSetup = useOpenCategorySetup();
  const navigate = useNavigate();

  const [selected, setSelected] = usePersistState('category-id', '', {
    keepOnUnmount: false,
  });
  const [filter, setFilter] = useState({
    keyword: '',
  });

  const onSubSelect = (item) => {
    setSelected(item.id);
    navigate(`${item.id}`);
  };

  useEffect(() => {
    if (selected || list?.length === 0) return;
    setSelected(head(list)?.id);
  }, [list, selected, setSelected]);

  return (
    <Card className="overflow-hidden">
      <section className="flex bg-white flex-grow static min-h-[calc(100vh_-_12rem)] overflow-hidden">
        <div className="border-r border-neutral-200 w-[260px] flex-shrink-0 flex flex-col">
          <div className="p-3 border-b border-neutral-200">
            <SearchBar
              name="keyword"
              value={filter.keyword}
              onChange={setFilter}
              inputClassName="!w-full"
              containerClassName="!w-full"
            />
          </div>
          <List
            data={list}
            isLoading={isLoading}
            selectedId={selected}
            onSelectRow={onSubSelect}
            render={(item) => (
              <div className="flex items-center px-4 py-3">
                <span className="text-sm font-medium">
                  {startCase(capitalize(item?.name))}
                </span>
              </div>
            )}
            selectedKey="id"
            containerClassName="!w-full"
            emptyStatement="No datasets match this search."
          />
          {/* aclHelper( HIDDEN
            'cms',
            'w',
            <Button
              onClick={() => openSetup({})}
              primary
              className="uppercase"
              size="sm"
            >
              add category
            </Button>,
          ) */}
        </div>

        <Routes>
          <Route
            path="top-ten-agency"
            element={<DataManagement code="top-ten-agency" />}
          />
          <Route
            path="top-ten-sender"
            element={<DataManagement code="top-ten-sender" />}
          />
          <Route
            path="balance-count"
            element={<DataManagement code="balance-count" editValueOnly />}
          />
          <Route
            path="graph-data"
            element={<DataManagement code="graph-data" />}
          />
          <Route path=":categoryId/*" element={<ContentDetails />} />
          {list?.length > 0 && (
            <Route
              index
              element={<Navigate replace to={`${head(list)?.id}`} />}
            />
          )}
        </Routes>
      </section>
    </Card>
  );
}

export default ContentManagement;
